export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/anders-jilden-000e7dff90534aec6ff363e60f6c09d7.jpg";